module.exports = __webpack_public_path__ + "static/logo-42e80983a91d5cab0452c7926246822e.png";